export enum PagePath {
  Languages = 'languages',
  Translations = 'translations',
  ErrorPage = 'error'
}
